module.exports = __webpack_public_path__ + "img/service_건강노화힐링산업.0e395ce8.png";